import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, LayoutDashboard } from 'lucide-react';

export const SubscriptionSuccessPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-green-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl border border-gray-200 p-8 lg:p-10 w-full max-w-md">
        <div className="text-center mb-6">
          <h1 className="text-3xl font-bold mb-4">
            <span className="text-gray-900">Game</span>
            <span className="text-green-600">Path</span>
          </h1>
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <CheckCircle className="w-8 h-8 text-green-600" />
          </div>
          <h2 className="text-xl font-bold text-gray-900 mb-2">Welcome to GamePath!</h2>
          <p className="text-gray-600">
            Thank you for subscribing. Your account is now active and ready to go.
          </p>
        </div>

        <div className="bg-green-50 border border-green-200 rounded-xl p-5 mb-6">
          <p className="text-sm text-green-800 text-center">
            You now have full access to player assessments, development tracking, and team management tools.
          </p>
        </div>

        <div className="text-center">
          <Link
            to="/dashboard"
            className="inline-flex items-center justify-center gap-2 w-full bg-blue-600 text-white py-3 px-4 rounded-lg font-medium hover:bg-blue-700 transition-colors"
          >
            <LayoutDashboard className="w-5 h-5" />
            Go to Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
};
